import React from 'react';

import {
  useNavigate,
  useParams,
  useSearchParams
} from 'react-router-dom';

import { routeDirectory } from 'modules';
import * as dataService from './dataService';



export const StoreReferralActivity: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams<{ storeId: string; }>();
  const [searchParams] = useSearchParams();
  const {
    storeId,
    orderNumber,
    customerEmail
  } = React.useMemo(
    () => {
      const storeId = params.storeId ?? '';
      const orderNumber = searchParams.get('orderNumber') ?? '';
      const customerEmail = searchParams.get('customerEmail') ?? '';
      return {
        storeId,
        orderNumber,
        customerEmail
      };
    },
    [
      params,
      searchParams
    ]
  );
  const queryTuple = dataService.useQuery({
    email: customerEmail,
    orderNumber
  });



  React.useEffect(
    () => {
      if (queryTuple.data.orderId && storeId) {
        navigate(routeDirectory.customer.orderDetail.path(queryTuple.data.orderId, storeId));
      }
    },
    [
      navigate,
      queryTuple.data.orderId,
      storeId
    ]
  );

  return null;
};
